import { createIcon } from '@chakra-ui/react';

export default createIcon({
  displayName: 'FilterIcon',
  viewBox: '0 0 24 24',
  path: (
    <g fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M21 8.25H10m-5.25 0H3" />
      <path d="M7.5 6v0a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z" clipRule="evenodd" />
      <path d="M3 15.75h10.75m5 0H21" />
      <path d="M16.5 13.5v0a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z" clipRule="evenodd" />
    </g>
  ),
});
